"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const color_1 = require("@treefort/lib/color");
const helpers_1 = require("../../lib/helpers");
const global_1 = __importDefault(require("./global"));
const { colors, spacing } = global_1.default;
exports.default = {
    colors: {
        background: {
            primary: (0, helpers_1.displayModeToken)({
                light: colors.white,
                dark: colors.gray950,
            }),
            secondary: (0, helpers_1.displayModeToken)({
                light: colors.gray100,
                dark: colors.gray900,
            }),
            tertiary: (0, helpers_1.displayModeToken)({
                light: colors.gray50,
                dark: colors.gray920,
            }),
            scrim: (0, helpers_1.displayModeToken)({
                light: (0, color_1.colorWithAlpha)(colors.gray950, 0.25),
                dark: (0, color_1.colorWithAlpha)(colors.gray850, 0.65),
            }),
        },
        formControl: (0, helpers_1.displayModeToken)({
            light: colors.gray100,
            dark: colors.gray800,
        }),
        border: {
            primary: (0, helpers_1.displayModeToken)({
                light: colors.gray200,
                dark: colors.gray900,
            }),
            accent: (0, helpers_1.displayModeToken)({
                light: (0, helpers_1.themeToken)("accentColorLight"),
                dark: (0, helpers_1.themeToken)("accentColorDark"),
            }),
            shadowAdjacent: (0, helpers_1.displayModeToken)({
                light: colors.gray50,
                dark: colors.gray900,
            }),
            focus: colors.blue500,
        },
        danger: colors.red500,
        success: colors.green500,
        accent: (0, helpers_1.displayModeToken)({
            light: (0, helpers_1.themeToken)("accentColorLight"),
            dark: (0, helpers_1.themeToken)("accentColorDark"),
        }),
        loading: {
            image: (0, helpers_1.displayModeToken)({
                light: colors.gray300,
                dark: colors.gray900,
            }),
            text: (0, helpers_1.displayModeToken)({
                light: colors.gray100,
                dark: colors.gray900,
            }),
        },
        feedback: {
            ripple: (0, helpers_1.displayModeToken)({
                light: (0, color_1.colorWithAlpha)(colors.gray950, 0.2),
                dark: (0, color_1.colorWithAlpha)(colors.gray100, 0.2),
            }),
            underlay: (0, helpers_1.displayModeToken)({
                light: (0, color_1.colorWithAlpha)(colors.gray950, 0.08),
                dark: (0, color_1.colorWithAlpha)(colors.gray100, 0.18),
            }),
        },
        text: {
            primary: (0, helpers_1.displayModeToken)({
                light: colors.gray800,
                dark: colors.gray200,
            }),
            secondary: (0, helpers_1.displayModeToken)({
                light: colors.gray600,
                dark: colors.gray500,
            }),
            translucent: (0, helpers_1.displayModeToken)({
                light: (0, color_1.colorWithAlpha)(colors.black, 0.9),
                dark: (0, color_1.colorWithAlpha)(colors.white, 0.9),
            }),
            highContrast: (0, helpers_1.displayModeToken)({
                light: colors.gray950,
                dark: colors.white,
            }),
            disabled: (0, helpers_1.displayModeToken)({
                light: colors.gray400,
                dark: colors.gray700,
            }),
            success: colors.green500,
            danger: colors.red500,
            accent: (0, helpers_1.displayModeToken)({
                light: (0, helpers_1.themeToken)("accentColorLight"),
                dark: (0, helpers_1.themeToken)("accentColorDark"),
            }),
        },
    },
    spacing: {
        pagePaddingHorizontal: (0, helpers_1.displayWidthToken)({
            0: spacing.large,
            1024: spacing.jumbo,
        }),
    },
};
